import type { AttachmentTargetType, CreateAttachmentBody } from '@/api/audioStudioApi';

/** A sound that can be attached: a studio track (st-…) or a curated library track (bs-track-…). */
export interface AttachableTrack {
  track_id: string;
  track_source: 'library' | 'studio';
  title: string;
}

export interface AttachSelection {
  campaignId: string;
  targetType: AttachmentTargetType;
  targetId: string;
  note?: string;
}

/** Body for POST /attachments; `null` until the selection is complete. Blank notes are dropped. */
export function buildAttachmentPayload(track: AttachableTrack, sel: AttachSelection): CreateAttachmentBody | null {
  if (!track.track_id || !sel.campaignId || !sel.targetId) return null;
  const note = sel.note?.trim();
  return {
    track_id: track.track_id,
    track_source: track.track_source,
    target_type: sel.targetType,
    target_id: sel.targetId,
    campaign_id: sel.campaignId,
    ...(note ? { note } : {}),
  };
}
